export const makeUnexpectedError = (error) => ({
    _tag: "UnexpectedError",
    error,
});
/** Error isn't a structured cloneable object. */
export const ensureTransferableError = (error) => {
    if (error instanceof Error)
        return {
            message: error.message,
            name: error.name,
            stack: error.stack,
        };
    return error;
};
